module.exports = global["$"] = require("-!C:\\wamp\\www\\prestashop_1.7.2.2\\themes\\01grid\\_dev\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 2
// module chunks = 0